export var MessageStatus;

(function (MessageStatus) {
  MessageStatus["Streaming"] = "streaming";
  MessageStatus["Done"] = "done";
  MessageStatus["Active"] = "active";
  MessageStatus["Stopped"] = "stopped";
})(MessageStatus || (MessageStatus = {}));